
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Text as TextIcon } from '../../../element/icons/text';
import ToolsBarItemButton from '../../../components/ToolsBar/ToolsBarItemButton';
import {
  ENABLE_TEXT_CONTENT_EDIT,
  SELECT_ANNOTATION,
  SET_ANNOTATION,
} from '../../../actions';
import { useStore } from '../../../hooks';
import { focusTextContentField } from '../../../hooks/textContentFieldFocus';
import buildDefaultTextAnnotation from '../../../utils/buildDefaultTextAnnotation';
import { TOOLS_IDS } from '../../../utils/constants';

const TextButton = ({ selectTool, isSelected = false, t }) => {
  const { dispatch, config, shownImageDimensions, adjustments } = useStore();

  const onClickTab = useCallback(
    (toolId) => {
      selectTool(toolId);

      const annotation = buildDefaultTextAnnotation({
        config,
        shownImageDimensions,
        adjustments,
      });

      dispatch({
        type: SET_ANNOTATION,
        payload: annotation,
      });
      dispatch({
        type: SELECT_ANNOTATION,
        payload: { annotationId: annotation.id },
      });
      dispatch({
        type: ENABLE_TEXT_CONTENT_EDIT,
        payload: { textIdOfEditableContent: annotation.id },
      });
      focusTextContentField();
    },
    [adjustments, config, dispatch, selectTool, shownImageDimensions],
  );

  return (
    <ToolsBarItemButton
      className="FIE_text-tool-button"
      id={TOOLS_IDS.TEXT}
      label={t('textTool')}
      Icon={TextIcon}
      onClick={onClickTab}
      isSelected={isSelected}
    />
  );
};


TextButton.propTypes = {
  selectTool: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default TextButton;
